import { render, staticRenderFns } from "./IdeaPlanShared.vue?vue&type=template&id=ef0e452a"
import script from "./IdeaPlanShared.vue?vue&type=script&lang=js"
export * from "./IdeaPlanShared.vue?vue&type=script&lang=js"
import style0 from "./IdeaPlanShared.vue?vue&type=style&index=0&id=ef0e452a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports